module.exports = __webpack_public_path__ + "img/57-r.edf9e711.png";